/* BabyBoom Theme Logic */
window.ShopifySwatches = window.ShopifySwatches || {};

document.addEventListener('DOMContentLoaded', () => {
    // 1. Hero Slider Logic
    function initHeroSlider(container) {
        if (!container) return;
        if (container.dataset.initialized === 'true') return;
        container.dataset.initialized = 'true';

        const slides = Array.from(container.querySelectorAll('.hero-slide'));
        const dots = Array.from(container.querySelectorAll('.slider-dot'));
        const prevBtn = container.querySelector('.slider-nav.prev');
        const nextBtn = container.querySelector('.slider-nav.next');
        const autoSpeed = parseInt(container.getAttribute('data-auto-speed')) || 5000;
        
        if (slides.length === 0) {
        }

        let currentSlide = 0;
        let slideInterval;

        // Find initial active slide
        const initialActive = slides.findIndex(s => s.classList.contains('active'));
        if (initialActive !== -1) currentSlide = initialActive;

        function showSlide(index) {
            if (slides.length === 0) return;
            
            // Loop around
            if (index < 0) index = slides.length - 1;
            if (index >= slides.length) index = 0;


            let direction = 'right';
            if (index < currentSlide) direction = 'left';
            if (currentSlide === slides.length - 1 && index === 0) direction = 'right';
            if (currentSlide === 0 && index === slides.length - 1) direction = 'left';
            
            slides.forEach((s, i) => {
                s.classList.remove('slide-in-right', 'slide-in-left', 'slide-out-right', 'slide-out-left');
                if (i === index) {
                    s.classList.add('active');
                    if (container.dataset.initialized === 'true') {
                        s.classList.add(direction === 'right' ? 'slide-in-right' : 'slide-in-left');
                    }
                } else if (i === currentSlide && container.dataset.initialized === 'true') {
                    s.classList.remove('active');
                    s.classList.add(direction === 'right' ? 'slide-out-left' : 'slide-out-right');
                } else {
                    s.classList.remove('active');
                }
            });

            dots.forEach((d, i) => {
                if (i === index) {
                    d.classList.add('active');
                } else {
                    d.classList.remove('active');
                }
            });
            
            currentSlide = index;
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                showSlide(currentSlide + 1);
            });
        }
        
        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                showSlide(currentSlide - 1);
            });
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                showSlide(index);
            });
        });

        function startAutoSlide() {
            stopAutoSlide();
            if (slides.length > 1) {
                slideInterval = setInterval(() => {
                    showSlide(currentSlide + 1);
                }, autoSpeed);
            }
        }

        function stopAutoSlide() {
            if (slideInterval) {
                clearInterval(slideInterval);
                slideInterval = null;
            }
        }

        // Delay the start of auto-rotation to prevent Lighthouse from registering slide-2 as LCP
        setTimeout(startAutoSlide, 5000);
        
        container.addEventListener('mouseenter', stopAutoSlide);
        container.addEventListener('mouseleave', startAutoSlide);

        // Expose for Shopify Editor
        container._showSlide = showSlide;
    }

    // Initialize on load
    const initAllSliders = () => {
        const sliders = document.querySelectorAll('[data-hero-slider]');
        sliders.forEach(slider => initHeroSlider(slider));
    };

    initAllSliders();

    // Shopify Editor Support
    document.addEventListener('shopify:section:load', (event) => {
        const slider = event.target.querySelector('[data-hero-slider]');
        if (slider) initHeroSlider(slider);
    });

    document.addEventListener('shopify:block:select', (event) => {
        const section = event.target.closest('.hero-section');
        const slider = section ? section.querySelector('[data-hero-slider]') : null;
        if (slider && slider._showSlide) {
            const selectedBlockId = event.detail.blockId;
            const slides = Array.from(slider.querySelectorAll('.hero-slide'));
            const index = slides.findIndex(s => s.id === `slide-${selectedBlockId}`);
            if (index !== -1) slider._showSlide(index);
        }
    });

    // 2. Product Tabs Logic
    const initTabs = () => {
        const tabBtns = document.querySelectorAll('.product-tab');
        const tabContents = document.querySelectorAll('.tab-content');

        tabBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const tabId = btn.getAttribute('data-tab');
                
                tabBtns.forEach(b => {
                    b.classList.remove('active');
                });
                btn.classList.add('active');

                tabContents.forEach(content => {
                    if (content.id === `tab-${tabId}`) {
                        content.classList.remove('hidden');
                    } else {
                        content.classList.add('hidden');
                    }
                });
            });
        });
    };

    // 3. Mobile Menu Logic
    const initMobileMenu = () => {
        const mobileMenuBtn = document.getElementById('mobile-menu-btn');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');

        if (mobileMenuBtn && mobileMenu && mobileMenuOverlay) {
            mobileMenuBtn.addEventListener('click', () => {
                mobileMenu.classList.remove('translate-x-full');
                mobileMenuOverlay.classList.remove('hidden');
                setTimeout(() => mobileMenuOverlay.style.opacity = '1', 10);
                document.body.style.overflow = 'hidden';
            });

            const closeMobile = () => {
                mobileMenu.classList.add('translate-x-full');
                mobileMenuOverlay.style.opacity = '0';
                setTimeout(() => mobileMenuOverlay.classList.add('hidden'), 300);
                document.body.style.overflow = '';
            };

            if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobile);
            mobileMenuOverlay.addEventListener('click', closeMobile);
        }
    };

    // 4. Header Sticky Logic
    const initHeaderSticky = () => {
        const header = document.getElementById('main-header');
        const placeholder = document.getElementById('header-placeholder');
        
        if (header) {
            let cachedHeight = 0;
            const updateHeight = () => {
                header.classList.remove('fixed-state');
                cachedHeight = header.offsetHeight;
            };
            if (window.requestIdleCallback) {
                window.requestIdleCallback(updateHeight);
            } else {
                setTimeout(updateHeight, 100);
            }

            window.addEventListener('resize', () => {
                updateHeight();
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 100) {
                    header.classList.add('fixed-state');
                    if (placeholder) placeholder.style.height = `${cachedHeight}px`;
                } else {
                    header.classList.remove('fixed-state');
                    if (placeholder) placeholder.style.height = '0px';
                }
            }, { passive: true });
        }
    };

    // 5. Collection View Toggle
    const initCollectionView = () => {
        const gridViewBtn = document.getElementById('grid-view');
        const listViewBtn = document.getElementById('list-view');
        const productGrid = document.querySelector('.product-grid');

        if (gridViewBtn && listViewBtn && productGrid) {
            gridViewBtn.addEventListener('click', () => {
                productGrid.classList.remove('is-list-view');
                gridViewBtn.classList.add('active');
                listViewBtn.classList.remove('active');
                localStorage.setItem('collection_view', 'grid');
            });

            listViewBtn.addEventListener('click', () => {
                productGrid.classList.add('is-list-view');
                listViewBtn.classList.add('active');
                gridViewBtn.classList.remove('active');
                localStorage.setItem('collection_view', 'list');
            });

            // Restore saved view
            const savedView = localStorage.getItem('collection_view');
            if (savedView === 'list') {
                listViewBtn.click();
            }
        }
    };

    // Split initializations to yield the main thread and keep TBT at 0ms
    if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
            initTabs();
            initMobileMenu();
            initHeaderSticky();
            initCollectionView();
        }, { timeout: 2000 });
    } else {
        setTimeout(initTabs, 10);
        setTimeout(initMobileMenu, 20);
        setTimeout(initHeaderSticky, 30);
        setTimeout(initCollectionView, 40);
    }
});

